import { TAGSvgIcon } from '@aspendental/shared-components-web';
import { Box } from '@mui/material';
import { stepIndicatorCompletedStyles, stepIndicatorCurrentStyles, stepIndicatorLineStyles, stepIndicatorUpcomingStyles, stepIndicatorWrapperStyles } from './StepIndicator.styles';
export enum StepIndicatorType {
  COMPLETED = 'COMPLETED',
  CURRENT = 'CURRENT',
  UPCOMING = 'UPCOMING',
}
type StepIndicatorProps = {
  stepIndicatorType: StepIndicatorType;
  isLastStep: boolean;
  dataTestId: string;
};
export const getStepIndicatorType = (selectedIndex: number, stepIndex: number) => {
  if (stepIndex === selectedIndex) {
    return StepIndicatorType.CURRENT;
  } else if (stepIndex > selectedIndex) {
    return StepIndicatorType.UPCOMING;
  }
  return StepIndicatorType.COMPLETED;
};
export const StepIndicator = ({
  stepIndicatorType,
  isLastStep,
  dataTestId
}: StepIndicatorProps) => {
  return <Box data-test-id={dataTestId} sx={stepIndicatorWrapperStyles} data-sentry-element="Box" data-sentry-component="StepIndicator" data-sentry-source-file="StepIndicator.tsx">
			{stepIndicatorType === StepIndicatorType.CURRENT && <Box sx={stepIndicatorCurrentStyles} />}
			{stepIndicatorType === StepIndicatorType.COMPLETED && <Box sx={stepIndicatorCompletedStyles}>
					<TAGSvgIcon icon="CheckFunc" style={{
        width: '10px',
        height: '10px',
        position: 'absolute'
      }} />
				</Box>}
			{stepIndicatorType === StepIndicatorType.UPCOMING && <Box sx={stepIndicatorUpcomingStyles} />}

			{!isLastStep && <Box sx={stepIndicatorLineStyles} />}
		</Box>;
};